import { pingEndpoints } from "../Helpers/AjaxHelper";
import { endTest, formatHostingServiceEndpoints } from "../Helpers/EndpointHelper";
import { displayStatusIcon, statusIconVals } from "../Helpers/DomHelper";
import { cancel, isLocal } from "../Helpers/ExecutionStatus";
const global = window;
const { selfHelp: { hostingServiceConfiguration, thirdPartyHostingServiceConfiguration, armEndpoint, reactViewDomain, resources } } = global;
const key = "clientSideDependencyEndpoints";
const selfHelpArmUri = "https://management.azure.com/healthcheck?api-version=2014-04-01";
// Where the responses from the API requests are stored
let endpointResponses;
// array of client dependency endpoints aside from extension trusted domains to be used depending on environment we are testing in
let cachedEndpoints = [];
/**
 * Returns cached endpoints or retrieves endpoints
 *
 * @returns Array of cached endpoints
 */
function getEndpoints() {
    if (cancel) {
        return;
    }
    if (cachedEndpoints.length === 0) {
        const armUri = isLocal ? selfHelpArmUri : armEndpoint;
        cachedEndpoints = [{ name: resources.Endpoints_ARM, uri: armUri }, { name: resources.Endpoints_reactViewDomain, uri: reactViewDomain }];
        formatEndpoints(hostingServiceConfiguration, false);
        formatEndpoints(thirdPartyHostingServiceConfiguration, true);
    }
    return cachedEndpoints;
}
function formatEndpoints(configurationList, thirdParty) {
    configurationList.forEach(configuration => {
        const configurationUri = formatHostingServiceEndpoints(configuration);
        cachedEndpoints.push({
            name: thirdParty ? resources.Endpoints_thirdPartyHostingService : resources.Endpoints_hostingService + ": " + configurationUri.toString(),
            uri: new URL("/api/ping", configurationUri).toString(),
        });
    });
}
/**
 * Calls helper function to get endpoint responses and finish test.
 */
async function pingClientSideDependencyEndpoints() {
    if (cancel) {
        return;
    }
    const endpoints = getEndpoints();
    const results = await pingEndpoints(endpoints, true);
    endpointResponses = results;
    endTest(key, endpointResponses);
}
/** Triggers beginning of test and update of DOM. */
export function startTest() {
    displayStatusIcon(key, statusIconVals.inProgress);
    pingClientSideDependencyEndpoints();
}
//# sourceMappingURL=ClientSideDiagnostics.js.map